import {Partner} from './partner/partner';
import {Document} from './document';
import {Chat} from './chat';
import {LoadUnit, LoadUnitTemplate} from './load-unit';
import {Location} from './location';
import {Equipment} from './equipment';
import {AnalyticOperation, AnalyticOperationData} from './analytic-operation';
import {Event, EventType, Flow} from './flow';
import {Service} from './service';
import {Project} from './project';
import {Motonave} from './motonave';
import {ProjectContainer} from './project-container';
import {Good} from './good';
import {Shipping} from './shipping';

export interface ServiceOrder {
  id: number,
  reference?: string;
  referenceCEC?: string;
  referenceCommercial?: string;
  imo?: boolean;
  state: string;
  driver?: Partner;
  mbl?: string;
  hbl?: string;
  originId?: number;
  origin?: Location;
  serviceTypeId?: number;
  serviceOrderId?: number;
  serviceId?: number;
  isActive?: boolean;
  createdAt: string;
  driverId?: number;
  loadUnitId?: number;
  loadUnit?: LoadUnit;
  originContactId?: number;
  destinationContactId?: number;
  destinationId?: number;
  finalDestinationId?: number;
  storageId?: number;
  shipping?: Shipping;
  shippingId?: number;
  flow?: Flow;
  shiftDeconsolidation?: string;
  deconsolidationTypeId?: number;
  equipmentIds?: number[];
  differentiatedBlock?: boolean;
  documents?: Document[];
  chatId: number;
  chat?: Chat;
  equipments?: Equipment[];
  analyticOperations?: AnalyticOperation[];
  events: Event[];
  isIntegrated: boolean;
  freeDays?: number;
  atDischargeEvent?: string;
  atdDischargeAvailable?: boolean;
  gateOutEvent?: string;
  emptyReturnEvent?: string;
  motonaveId?: number;
  motonave?: Motonave;
  projectContainerId?: number;

  projectContainer?: ProjectContainer;
  service?: Service;
  project?: Project;

  initialEta?: string,
  mojitoShipmentLandId?: number,
  mojitoShipmentSeaId?: number,
  mojitoIntegrationStatus: 'None' | 'Pending' | 'Integrated' | 'Failed';
  mojitoIntegrationStatusDescription?: string;
  functionStatusIntegration?: string;
  tentativeDeliveryDate?: string | null;
  tentativePickupDate?: string | null;

  paymentStatusMetrics?: {
    serviceCompletionDate: string;
  }

  // Propiedades auxiliares del front
  hasIngreso?: boolean;
  hasGasto?: boolean;
  moneyData?: AnalyticOperationData;
  aoListAvaiable?: AnalyticOperation[];
  contenedor?:string
}

/** Respuesta mínima de GET /core/api/ServiceOrder/by-service/:serviceId (id, reference, state) */
export interface ServiceOrderMinimal {
  id: number;
  reference: string;
  state: string;
}

export interface IntegrationFunctionResponse {
  "name": string,
  "instanceId": string,
  "runtimeStatus": string,
  "input": string,
  "customStatus": {
    "IsError": boolean,
    "Message": string,
    "LandId": number | null,
    "SeaId": number | null
  },
  "output": any,
  "createdTime": string,
  "lastUpdatedTime": string
}

export type ServiceOrderCreate = Omit<ServiceOrder, 'id'>

export interface ContainerTypes {
  id: number,
  code: string,
  description: string
}

export interface ServiceOrderTemplate extends Omit<
  ServiceOrder,
  | 'reference'
  | 'containerReference'
  | 'equipmentIds'
  | 'chatId'
  | 'containerTypeId'
  | 'mojitoShipmentLandId'
  | 'mojitoShipmentSeaId'
  | 'mojitoIntegrationStatus'
  | 'mojitoIntegrationStatusDescription'
  | 'isIntegrated'
> {
  loadUnitTemplate?: LoadUnitTemplate;
}
export interface ServiceOrderTemplateCreate {
  loadUnitTemplateId: number,
  createdAt: string,
  serviceId: number,
  isActive: boolean,
  differentiatedBlock: boolean,
  originContactId?: number,
  originId?: number,
  destinationContactId?: number,
  destinationId?: number,
}


export interface ServiceOrderWithTemplateParams {
  serviceOrderTemplateId: number;
  serviceId: number;
  projectContainersIds?: number[];
  quantity?: number
}

export interface UpdateServiceOrderWithTemplateParams {
  serviceOrderTemplateId: number;
  serviceOrdersIds: number[];
}

export interface UpdateMultipleServiceOrderState {
  eventTypeId: number,
  serviceOrderIds: number[],
  dateTime: string
}

export interface ServiceOrderGroup {
  id: string;
  eventTypeName: string;
  serviceOrders: ServiceOrder[];
  eventType: EventType;
  selectedEventType?: EventType | null;
}

export interface BatchAssignEquipmentPayload {
  serviceOrderIds: number[];
  equipmentId: number;
}

export interface BatchAssignDriverPayload {
  serviceOrderIds: number[];
  driverId: number;
}

export interface BatchAssignTransportDetailPayload {
  assignments: {
    serviceOrderId: number;
    driverId: number | null;
    truckEquipmentId: number | null;
    trailerEquipmentId: number | null;
    tentativeDeliveryDate: string | null;
    tentativePickupDate: string | null;
  }[];
}

export interface BatchAssignResult {
  data?: {
    results: BatchAssignServiceOrderResult[];
  };
  results: BatchAssignServiceOrderResult[];
}

export interface BatchAssignServiceOrderResult {
    serviceOrderId: number;
    success: boolean;
    updated?: boolean;
    error?: string | null;
}
